import { useNavigate } from 'react-router-dom';
import logo from '../assets/images/logos/logo-long-transparent.svg';

const NotFound = () => {
    const navigate = useNavigate();
    return (
       <div className="w-screen h-screen flex flex-col justify-center items-center bg-white gap-10">
            <img src={logo} width={200} className='absolute top-10 left-10 cursor-pointer' alt="logo" onClick={() => navigate('/')}/>
            <h1 className="text-6xl text-[#7F7F7F] font-bold">NOT FOUND</h1>
            <p className="text-[#7F7F7F]">Oops, the page you are looking for does not exist</p>
            <div className="bg-[#7C939A] hover:bg-[#57676c] text-white font-bold py-2 px-4 rounded cursor-pointer" onClick={() => navigate('/')}>Back to Home</div>
       </div>
    );
}

export default NotFound;